import React, { ReactNode } from "react";
import DeviceContext from "../../../../service/indentifyDevice";
import { AObCommReq, AObCommHist } from "../../../../service/orderBook/obApiService";
import { commNav } from "../../obConstants";
import { Idevice } from "../../../../types/device";
import moment from "moment";
import NoDataContainer from "../../../../generic/noDataContainer";
import { SDevWiseStateComp } from "../obDeviceComp";

import ObCommodities from "../../instruments/secondaryMarket/obCommodities";
import ObCommoditiesMob from "../../instruments/secondaryMarket/obCommoditiesMob";
import Loader from "../../../../generic/loader";
import { IListObj } from "../../../../types/genericTypes";
export interface IObCommContainerProps {
	match?: any;
}

const ObCommContainer: React.FC<IObCommContainerProps> = (props) => {
	const [hidepgNav, setHidePageNav] = React.useState<boolean>(false);
	const [instrument, setInstrument] = React.useState<ReactNode>(<></>);
	let filteredData: Array<{}> = [];
	const obLoader = (
		<div className="loaderWrap">
			<Loader size={20} color="blue" />
		</div>
	);

	// priNavOptions do not change (no need of state)
	const priNavOptions: Array<IListObj> = [
		{ value: "today", display: "Today's orders", href: commNav.today },
		{ value: "history", display: "History", href: commNav.history }
	];

	//url params controlled vars
	let activeSecNav: string = props.match.params.secNav.toLowerCase();
	let history: boolean = props.match.params.pageNav === priNavOptions[1].value ? true : false;

	const setNHandle = (data: any) => {
		filteredData = data;
		handleSecNav(activeSecNav);
	};

	const CommOrderBookRes = (res: any) => {
		res.data ? setNHandle(res.data.ord) : setNHandle([]);
	};

	const CommOrderBookHistRes = (res: any) => {
		if (history) {
			res.data ? setNHandle(res.data.hstOrdBk) : setNHandle([]);
		}
	};

	//handle page navigation today's, history data
	const handlePageNav = (selectVal: string) => {
		switch (selectVal) {
			case "history":
				history = true;
				setNHandle([]);
				break;
			case "today":
				history = false;
				setInstrument(obLoader);
				AObCommReq(CommOrderBookRes);
				break;
			default:
				console.log("not found");
				break;
		}
	};

	React.useEffect(() => {
		handlePageNav(props.match.params.pageNav);
	}, [props.match.params.pageNav]);

	const getDates = (fromDt: Date, toDate: Date) => {
		if (history) {
			AObCommHist(CommOrderBookHistRes, moment(fromDt).format("MM/DD/YYYY"), moment(toDate).format("MM/DD/YYYY"));
		}
	};

	const handleDevice: Idevice = DeviceContext();
	//toggler to show and hide the page navigation in the events of any operation
	const hidePageNav = (toggle: boolean) => {
		setHidePageNav(toggle);
	};
	//handles section navigation based on page navigation
	const handleSecNav = (nav: string) => {
		let inst: ReactNode = <></>,
			nodataNode: ReactNode = <></>;
		//show no data container
		if (filteredData.length === 0) {
			nodataNode = (
				<NoDataContainer
					txtHeading={history ? "" : `You haven’t placed any ${nav} orders today`}
					txtSubHeading={
						!history ? "Investing today can help you grow your wealth" : "There are no orders for the selected date range and asset class"
					}
					btnDet={{
						txt: history ? "Today's Orders" : "Place Order",
						href: history ? "today" : "temp",
						clickHandler: () => {},
						type: history ? "bLink" : "btn"
					}}
				/>
			);
		}
		if (history || filteredData.length !== 0) {
			inst =
				handleDevice.isDesktop || handleDevice.isTablet ? (
					<ObCommodities data={filteredData} isHistory={history} hidePageNav={hidePageNav} getDates={getDates} />
				) : (
					<ObCommoditiesMob data={filteredData} isHistory={history} hidePageNav={hidePageNav} getDates={getDates} />
				);
		}
		setInstrument(
			<>
				{inst}
				{nodataNode}
			</>
		);
	};
	return <>{SDevWiseStateComp(priNavOptions, instrument, hidepgNav)}</>;
};

export default ObCommContainer;
